<template>
  <span class="user__short-name icon--small">{{ shortName }}</span>
</template>

<script>
export default {
  name: 'UserShortName',
  props: {
    shortName: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.user__short-name {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 0;
  color: var(--c-secondary);
  background-color: var(--c-secondary-400);
  border-radius: 100%;
  border: 2px solid #fff;
}
</style>
